<template>
  <div
    v-test-id="'activity-sidebar'"
    v-if="isSidebarActive"
    class="c-activity-nav-sidebar__wrapper"
    :class="{
      'c-activity-nav-sidebar__wrapper--expanded-lg': showExpandedSidebar,
      'c-activity-nav-sidebar__wrapper--expanded-md': showExpandedByDefaultSidebar
    }"
  >
    <div
      v-test-id="'activity-view'"
      class="c-activity-sidebar-view__wrapper"
      v-if="isActivitySidebarOpen"
    >
      <template
        v-for="(module, name) in enabledSidebarModules"
      >
        <portal-target
          v-test-id="`activity-portal-${module.portalName}`"
          :key="name"
          :name="`activity-sidebar-${module.portalName}`"
        />
      </template>
    </div>
    <div class="c-activity-sidebar-links__wrapper u-p3">
      <nav
        class="c-activity-sidebar-link"
        v-for="(module, name) in enabledSidebarModules"
        :key="name"
      >
        <el-tooltip
          :content="module.label"
          transition="none"
          :visible-arrow="false"
          placement="left"
        >
          <fa-icon
            v-test-id="`activity-link-${module.portalName}`"
            @click="onIconClick(name)"
            :icon="module.icon"
            size="lg"
            :data-element="`activity-sidebar-link-${module.portalName}`"
          />
        </el-tooltip>
      </nav>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex'

export default {
  name: 'ActivityNavSidebar',
  watch: {
    enabledSidebarModules: function () {
      // if an active module is disabled, and activity sidebar is opened,
      // we need to close the activity sidebar as no component should be displayed.
      if (this.isActivitySidebarOpen && !this.selectedModule) {
        this.toggleActivitySidebar(false)
        this.unsetActivitySidebarActiveModule()
      }
    }
  },
  computed: {
    ...mapState('activity', [
      'isActivitySidebarOpen',
      'activitySidebarActiveModule',
      'activitySidebarExpanded'
    ]),
    ...mapGetters('activity', [
      'isSidebarActive',
      'enabledSidebarModules',
      'activitySidebarModulesNames'
    ]),
    selectedModule () {
      return this.enabledSidebarModules[this.activitySidebarActiveModule]
    },
    showExpandedSidebar () {
      return this.isActivitySidebarOpen && this.activitySidebarExpanded
    },
    showExpandedByDefaultSidebar () {
      return this.isActivitySidebarOpen && this.selectedModule && this.selectedModule.expandByDefault
    }
  },
  created () {
    // Always stay collapsed when vue instance is created.
    this.toggleActivitySidebar(false)
    // Due to vue-extend-layout implementation we need to disable the ActivitySidebar
    // when switching between layout to avoid the re-rendering of children components
    this.disableAllModules()
  },
  methods: {
    ...mapMutations('activity', [
      'unsetActivitySidebarActiveModule',
      'setActivitySidebarActiveModule',
      'toggleActivitySidebar',
      'enableModule',
      'disableModule',
      'disableAllModules'
    ]),
    onIconClick (name) {
      // Switch view
      if (this.isActivitySidebarOpen && this.activitySidebarActiveModule !== name) {
        this.setActivitySidebarActiveModule(name)
        return
      }

      // Toggle activity sidebar
      this.setActivitySidebarActiveModule(this.isActivitySidebarOpen ? null : name)
      this.toggleActivitySidebar()
    }
  }
}
</script>
